import React from "react";
import * as animationAccount from "./Account_Created_Lottie.json";
import "./Account_Created_Lottie.css";
import Lottie from "react-lottie";

export const Account_Created_Successfully = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationAccount,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="success_div">
        <div className="account-lottie">
          <Lottie className="me-auto" options={defaultOptions} />
        </div>
      </div>
    </section>
  );
};
